export default __webpack_public_path__ + "static/media/right-arrow-square.f113d288.svg";